import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-unificator/services';
import { TranslatePipe } from '../../../../../services/translation/translate.pipe';
import { AsyncPipe } from '@angular/common';
import { EpmCountryRestrictionService } from 'src/app/core/services/epm-country-restriction.service';

@Component({
    selector: 'app-cookie-message-content',
    templateUrl: './cookie-message-content.component.html',
    styleUrls: ['./cookie-message-content.component.scss'],
    imports: [AsyncPipe, TranslatePipe]
})
export class CookieMessageContentComponent {

  private _router = inject(Router);
  private _cookies = inject(CookieService);
  public epm = inject(EpmCountryRestrictionService);

  goToPolicy() {
    this._router.navigateByUrl(`/privacy-policy`);
  }

  cookiesAccepted() {
    this._cookies.set('isCookiesAccepted', 'true', 999, '/');
  }
}
